type Milliseconds = number;

const DEFAULT_LOCK_TIMEOUT = 5000;

export class Locker {
    private static instance: Locker

    private locks: { [key: string]: boolean };

    private constructor() {
        this.locks = {};
    }

    public static getInstance(): Locker {
        if (!Locker.instance) {
            Locker.instance = new Locker();
        }
        return Locker.instance;
    }

    public hasLock(key: string): boolean {
        return !!(this.locks[key]);
    }

    public setLock(key: string): boolean {
        if (this.hasLock(key)) {
            return false;
        }
        this.locks[key] = true;
        return true;
    }

    public setTempLock(key: string, timeout: Milliseconds = DEFAULT_LOCK_TIMEOUT): boolean {
        if (!this.setLock(key)) {
            return false;
        }

        setTimeout(() => {
            this.releaseLock(key);
        }, timeout);
        return true;
    }

    public releaseLock(key: string) {
        if (this.locks[key]) {
            delete (this.locks[key]);
        }
    }
}
